import { useForm, useController } from 'react-hook-form'
import { EntityType, DocumentCategory, DocumentPhase } from '../constants'
import { createCustomEntityId, parseCustomEntityId } from '../utils'

const createFormDefaultValues = ({ editingAttrs, creatingAttrs }) => {
  if (editingAttrs) {
    const { document, owner } = editingAttrs

    return {
      name: document.title || '',
      description: document.instructions || '',
      category: document.category || DocumentCategory.guarantor_default,
      phase: document.phase || DocumentPhase.main,
      adminOnly: Boolean(document.adminOnly).toString(),
      esignable: Boolean(document.esignable).toString(),
      entity: createCustomEntityId(owner),
    }
  }

  const { baseEntity, baseCategory } = creatingAttrs
  return {
    name: '',
    description: '',
    category: baseCategory || DocumentCategory.guarantor_default,
    phase: DocumentPhase.main,
    adminOnly: Boolean(true).toString(),
    esignable: Boolean(false).toString(),
    entity: createCustomEntityId(baseEntity),
  }
}

function useDocumentForm({ editingAttrs, creatingAttrs }) {
  const { register, handleSubmit, watch, control, setValue, formState } =
    useForm({
      defaultValues: createFormDefaultValues({ editingAttrs, creatingAttrs }),
    })

  const entityField = useController({ name: 'entity', control }).field
  const phase = watch('phase')
  const category = watch('category')

  const onEntityChange = (e) => {
    const { entityType: newEntityType } = parseCustomEntityId(e.target.value)

    if (newEntityType === EntityType.Business)
      setValue('category', DocumentCategory.business_entity)
    else if (newEntityType === EntityType.Guarantor)
      setValue('phase', DocumentPhase.main)

    entityField.onChange(e)
  }

  return {
    register,
    handleSubmit,
    formState,
    phase,
    category,
    entityField: { ...entityField, onChange: onEntityChange },
  }
}

export default useDocumentForm
